import { formAddressToCustomerAdapter } from 'shared/lib';
import type { TLoansCustomerPledgeEstateData } from 'shared/types/TLoansService';

import type { TPledgeEstateFields } from '../types';

export const formDataToLoansCustomerPledgeEstateAdapter = (
  formData?: TPledgeEstateFields,
): TLoansCustomerPledgeEstateData | undefined => {
  if (!formData) {
    return undefined;
  }

  return {
    isOwner: Boolean(formData.isOnlyOwner),
    address: formAddressToCustomerAdapter(formData.pledgeEstateAddress, {
      flat: formData.pledgeEstateAddressFlat,
      locationRoute: null,
    })!,
    otherOwners: formData.otherOwnerFullName
      ? [
          {
            fio: formData.otherOwnerFullName?.value || '',
            phone: formData.otherOwnerPhone,
            maritalStatus: formData.otherOwnerMaritalStatus?.value as never,
            relation: formData.relationship?.value as never,
          },
        ]
      : null,
  };
};
